import EquationsLogo from '~/assets/drill/equations'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function Equations({
  title,
  completed,
  path,
}: {
  title: string
  completed: boolean
  path: string
}): React.ReactElement {
  const gridMobile = 'row-start-15 row-end-17 col-start-2 col-end-4'
  const gridTablet = 'md:row-start-3 md:row-end-3 md:col-start-5 md:col-end-7'
  const gridDesktop = 'xl:row-start-3 xl:row-end-3 xl:col-start-3 xl:col-end-5'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={EquationsLogo}
      imageClassNames="h-8"
      path={path}
      title={title}
    />
  )
}
